import { Box, Button, Container } from "@mui/material";
import { FlexBox } from "components/flex-box";
import React from "react";
import { H4, H5, Paragraph } from "components/Typography";
import ShopLayout1 from "components/layouts/ShopLayout1";
import CategorySectionHeader from "components/CategorySectionHeader";
import { colors, drjInfo, openFacebookPage } from "common";
import Link from "next/link";
import EmailIcon from "@mui/icons-material/Email";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Image from "components/BazarImage";
import BazarButton from "components/BazarButton";

const Corporate = () => {
  return (
    <ShopLayout1 title="PC Worth Corporate">
      <Container maxWidth="lg" sx={{ p: 2, minHeight: "60vh", marginTop: 4 }}>
        <CategorySectionHeader title="PC Worth Corporate" />
        <H4 mt={4}>Elevate Your Business with Our Premium IT Solutions</H4>
        <Paragraph mt={1}>
          At PC Worth, we understand that businesses need reliable, efficient,
          and cutting-edge technology to thrive in today&lsquo;s competitive
          landscape. Our Corporate Solutions are tailored to meet the unique
          needs of companies of all sizes, offering top-tier products and
          exceptional services that help you achieve your business goals.
        </Paragraph>

        <H4 mt={5}>Why Choose PC Worth for Your Corporate IT Needs?</H4>
        <FlexBox ml={4} mt={1}>
          <ul style={{ listStyleType: "disc" }}>
            <li>
              <strong>COMPETITIVE PRICING:</strong> Take advantage of our
              corporate pricing and volume discounts to get the best value for
              your investment.
            </li>
            <li>
              <strong>EXPERT SUPPORT AND CONSULTATION:</strong> Our certified
              technicians and consultants are available to provide expert advice
              and support.
            </li>
            <li>
              <strong>FLEXIBLE PAYMENT OPTIONS:</strong> Choose from various
              payment methods to suit your financial
              planning.
            </li>
          </ul>
        </FlexBox>

        <H4 mt={4}>Contact Us</H4>
        <Paragraph mt={1}>
          Ready to take your business to the next level with PC Worth Corporate
          Solutions? Contact us today and discover how we can help you achieve
          your business goals.
        </Paragraph>

        <H4 mt={4}>How to Get Started</H4>
        <Paragraph mt={1}>
          Getting started with PC Worth Corporate Solutions is easy. Simply
          reach out to our corporate sales team at{" "}
          <a
            style={{ color: colors.link, fontWeight: "600" }}
            href={`mailto: ${drjInfo?.businessEmail}`}
          >
            {drjInfo?.businessEmail}
          </a>{" "}
          or contact us at our viber{" "}
          <a
            href={drjInfo?.viber}
            style={{ color: colors.link, fontWeight: "600" }}
          >
            {drjInfo?.cellNo2}
          </a>
          . We’ll schedule a consultation to discuss your requirements and
          provide a customized proposal.
        </Paragraph>

        <Box mt={5}>
          <Link href={`mailto: ${drjInfo?.businessEmail}`} passHref>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              startIcon={<EmailIcon />}
            >
              <H5>Email us at {drjInfo?.businessEmail}</H5>
            </Button>
          </Link>
          <Link href={drjInfo?.viber} passHref>
            <Button
              fullWidth
              style={{ marginTop: 15 }}
              variant="outlined"
              color="secondary"
              startIcon={
                <Image
                  src="/assets/images/icons/viber-purple.svg"
                  alt="viber"
                  width={20}
                  height={20}
                />
              }
            >
              <H5>Contact us on viber {drjInfo?.cellNo2}</H5>
            </Button>
          </Link>
          <BazarButton
            variant="text"
            fullWidth
            sx={{ marginTop: 2 }}
            color="secondary"
            onClick={openFacebookPage}
            startIcon={<ChatBubbleOutlineIcon />}
          >
            <H5>Contact us on our facebook page </H5>
          </BazarButton>
        </Box>
      </Container>
    </ShopLayout1>
  );
};

export default Corporate;
